<rt-dialog-header [heading]="heading" />
<rt-dialog-body>
  <rt-box variant="vertical">
    <rt-heading variant="heading">
      {{ 'app.candidate.admin_select.share_with_team.job_select_dialog.heading' | translate }}
    </rt-heading>
    <rt-heading variant="subheading light">
      {{ 'app.candidate.admin_select.share_with_team.job_select_dialog.subheading' | translate }}
    </rt-heading>
    <rt-offer-select
      [offers]="selectOptions"
      [formControl]="formControl"
      [hasSearch]="false"
      [hasInputTrigger]="false"
      [buttonVariant]="'outline'"
      [includeEmptyOption]="false"
      [showStatus]="true"
      margin-top-small-x
    />
  </rt-box>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="plain" (click)="cancel()">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button [disabled]="!selectOptions?.length" variant="primary" (click)="submit()">
    {{ 'app.common.continue' | translate }}
  </rt-button>
</rt-dialog-footer>
